// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-button-tooltip {
  /* Typography */
  --perxis-auto-button-tooltip-font-family-inner: var(
    --perxis-auto-button-tooltip-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-button-tooltip-font-size-inner: var(
    --perxis-auto-button-tooltip-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-button-tooltip-font-weight-inner: var(--perxis-auto-button-tooltip-font-weight, 400);
  --perxis-auto-button-tooltip-letter-spacing-inner: var(
    --perxis-auto-button-tooltip-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-button-tooltip-line-height-inner: var(
    --perxis-auto-button-tooltip-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-button-tooltip-text-transform-inner: var(--perxis-auto-button-tooltip-text-transform, none);
  --perxis-auto-button-tooltip-color-inner: var(
    --perxis-auto-button-tooltip-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-button-tooltip-active-color-inner: var(
    --perxis-auto-button-tooltip-active-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-button-tooltip-hover-color-inner: var(
    --perxis-auto-button-tooltip-hover-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-button-tooltip-background-color-inner: var(--perxis-auto-button-tooltip-background-color, transparent);
  --perxis-auto-button-tooltip-active-background-color-inner: var(
    --perxis-auto-button-tooltip-active-background-color,
    transparent
  );
  --perxis-auto-button-tooltip-icon-color-inner: var(
    --perxis-auto-button-tooltip-icon-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  --perxis-auto-button-tooltip-icon-active-color-inner: var(
    --perxis-auto-button-tooltip-icon-active-color,
    var(--perxis-auto-root-eighth-color-inner)
  );
  --perxis-auto-button-tooltip-icon-hover-color-inner: var(
    --perxis-auto-button-tooltip-icon-hover-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-button-tooltip-icon-font-size-inner: var(--perxis-auto-button-tooltip-icon-font-size, 24px);
  /* End Typography */
  /* Padding */
  --perxis-auto-button-tooltip-icon-padding-inner: var(--perxis-auto-button-tooltip-icon-padding, 0);
  /* End Padding */
  --perxis-auto-button-tooltip-active-border-radius-inner: var(--perxis-auto-button-tooltip-active-border-radius, 0);
}
.perxis-auto-1_16_13-button-tooltip .perxis-auto-1_16_13-button-tooltip__trigger.perxis-auto-1_16_13-button-tooltip__trigger--hidden {
  display: none;
}
.perxis-auto-1_16_13-button-tooltip .perxis-auto-1_16_13-tooltip-button,
.perxis-auto-1_16_13-button-tooltip .perxis-auto-1_16_13-tooltip-trigger {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.perxis-auto-1_16_13-button-tooltip .perxis-auto-1_16_13-button-link {
  --perxis-auto-button-font-family: var(--perxis-auto-button-tooltip-font-family-inner);
  --perxis-auto-button-font-size: var(--perxis-auto-button-tooltip-font-size-inner);
  --perxis-auto-button-font-weight: var(--perxis-auto-button-tooltip-font-weight-inner);
  --perxis-auto-button-letter-spacing: var(--perxis-auto-button-tooltip-letter-spacing-inner);
  --perxis-auto-button-line-height: var(--perxis-auto-button-tooltip-line-height-inner);
  --perxis-auto-button-text-transform: var(--perxis-auto-button-tooltip-text-transform-inner);
  --perxis-auto-button-icon-font-size: var(--perxis-auto-button-tooltip-icon-font-size-inner);
  --perxis-auto-button-icon-gap-normal: 8px;
  --perxis-auto-button-link-color: var(--perxis-auto-button-tooltip-color-inner);
  --perxis-auto-button-link-hover-color: var(--perxis-auto-button-tooltip-hover-color-inner);
  --perxis-auto-button-link-background-color: var(--perxis-auto-button-tooltip-background-color-inner);
  --perxis-auto-button-link-hover-background-color: var(--perxis-auto-button-tooltip-hover-background-color-inner);
  --perxis-auto-button-link-icon-color: var(--perxis-auto-button-tooltip-icon-color-inner);
  --perxis-auto-button-link-icon-hover-color: var(--perxis-auto-button-tooltip-icon-hover-color-inner);
}
.perxis-auto-1_16_13-button-tooltip .perxis-auto-1_16_13-button-link .perxis-auto-1_16_13-button__icon {
  padding: var(--perxis-auto-button-tooltip-icon-padding-inner);
  background-color: var(--perxis-auto-button-tooltip-background-color-inner);
}
.perxis-auto-1_16_13-button-tooltip .perxis-auto-1_16_13-button-link.perxis-auto-1_16_13-button-tooltip__button.perxis-auto-1_16_13-button-tooltip__button--active {
  --perxis-auto-button-link-background-color: transparent;
  --perxis-auto-button-link-hover-background-color: transparent;
  --perxis-auto-button-link-icon-color: var(--perxis-auto-button-tooltip-icon-active-color-inner);
  --perxis-auto-button-link-color: var(--perxis-auto-button-tooltip-active-color-inner);
}
.perxis-auto-1_16_13-button-tooltip .perxis-auto-1_16_13-button-link.perxis-auto-1_16_13-button-tooltip__button.perxis-auto-1_16_13-button-tooltip__button--active .perxis-auto-1_16_13-button__icon {
  background-color: var(--perxis-auto-button-tooltip-active-background-color-inner);
  border-radius: var(--perxis-auto-button-tooltip-active-border-radius-inner);
}

.perxis-auto-1_16_13-button-tooltip__clickable-tooltip {
  --perxis-auto-button-tooltip-clickable-max-width-inner: var(--perxis-auto-button-tooltip-clickable-max-width, 287px);
  --perxis-auto-button-tooltip-clickable-padding-inner: var(--perxis-auto-button-tooltip-clickable-padding, 16px 18px);
  --perxis-auto-button-tooltip-clickable-border-radius-inner: var(
    --perxis-auto-button-tooltip-clickable-border-radius,
    16px
  );
  --perxis-auto-button-tooltip-clickable-color-inner: var(
    --perxis-auto-button-tooltip-clickable-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-button-tooltip-clickable-background-color-inner: var(
    --perxis-auto-button-tooltip-clickable-background-color,
    var(--perxis-auto-button-first-color-inner)
  );
}
.perxis-auto-1_16_13-button-tooltip__clickable-tooltip.ant-5_17_0-tooltip {
  --perxis-auto-tooltip-max-width: var(--perxis-auto-button-tooltip-clickable-max-width-inner);
  --perxis-auto-tooltip-padding: var(--perxis-auto-button-tooltip-clickable-padding-inner);
  --perxis-auto-tooltip-border-radius: var(--perxis-auto-button-tooltip-clickable-border-radius-inner);
  --perxis-auto-tooltip-color: var(--perxis-auto-button-tooltip-clickable-color-inner);
  --perxis-auto-tooltip-background-color: var(--perxis-auto-button-tooltip-clickable-background-color-inner);
}

.perxis-auto-1_16_13-button-tooltip__hoverable-tooltip {
  --perxis-auto-button-tooltip-hoverable-max-width-inner: var(--perxis-auto-button-tooltip-hoverable-max-width, 287px);
  --perxis-auto-button-tooltip-hoverable-padding-inner: var(--perxis-auto-button-tooltip-hoverable-padding, 6px 12px);
  --perxis-auto-button-tooltip-hoverable-border-radius-inner: var(
    --perxis-auto-button-tooltip-hoverable-border-radius,
    8px
  );
  --perxis-auto-button-tooltip-hoverable-background-color-inner: var(
    --perxis-auto-button-tooltip-hoverable-background-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-tooltip-hoverable-color-inner: var(
    --perxis-auto-button-tooltip-hoverable-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
}
.perxis-auto-1_16_13-button-tooltip__hoverable-tooltip.ant-5_17_0-tooltip {
  --perxis-auto-tooltip-max-width: var(--perxis-auto-button-tooltip-hoverable-max-width-inner);
  --perxis-auto-tooltip-padding: var(--perxis-auto-button-tooltip-hoverable-padding-inner);
  --perxis-auto-tooltip-border-radius: var(--perxis-auto-button-tooltip-hoverable-border-radius-inner);
  --perxis-auto-tooltip-color: var(--perxis-auto-button-tooltip-hoverable-color-inner);
  --perxis-auto-tooltip-background-color: var(--perxis-auto-button-tooltip-hoverable-background-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
